import axios from 'axios';

// Create axios instance with default config
const axiosInstance = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Add response interceptor to handle common errors
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            // Log specific error details for debugging
            console.error('API Error:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        }
        return Promise.reject(error);
    }
);

export default axiosInstance; 